// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Azerbaijan from '../_raw/flag/icon_flag_azerbaijan.png';

export default () => <img src={Azerbaijan} alt="Azerbaijan" />;
